import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import SidePanelRecallsView from "../../layout/SidePanel/layouts/SidePanelRecallsView";

export const RecallsSchema: ISchema = {
    displayName: "Recalls",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelRecallsView data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            displayName: 'Id',
            type: PropertyTypes.string,
            key: true,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            descriptor: true,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'lineItemQuantity',
            displayName: 'Quantity',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'priority',
            displayName: 'Priority',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'requestType',
            displayName: 'Request Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'dateRequested',
            displayName: 'Requested At',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
        {
            name: 'recallStatus',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
            children: []
        } as ISchemaProperty,
    ],

    children: [
        { entityName: EntityNames.recallLineItems, displayName: "Items", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, navPropertyName: "RecallId", canAdd: false } as ISchemaChild,
        { entityName: EntityNames.audits, displayName: "Audit Trail", cantView: true, viewType: EntityViewTypes.list } as ISchemaChild
    ],
};
